import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";
import logger from "redux-logger";
import { applyMiddleware, compose, createStore } from "redux";
import { createEpicMiddleware } from "redux-observable";
import rootEpic from "../epics/index";
import createRootReducer from "../redux/reducers/index";

export const browserHistory = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});
const epicMiddleware = createEpicMiddleware();

const configureStore = () => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const store = createStore(
    createRootReducer(browserHistory),
    composeEnhancers(
      applyMiddleware(logger, routerMiddleware(browserHistory), epicMiddleware)
    )
  );

  epicMiddleware.run(rootEpic);

  return store;
};

export default configureStore;
